"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPerceptionAccount = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ECountry_1 = require("../../enums/Country/ECountry");
const Resource_1 = __importDefault(require("../Resource"));
function hasPerceptionAccount(obj) {
    return [obj.perceptionTitularyName, obj.perceptionBankDomiciliation, obj.perceptionIban, obj.perceptionBic].some((value) => value != null && value !== "");
}
exports.hasPerceptionAccount = hasPerceptionAccount;
class SubscriptionBankDetailsResource extends Resource_1.default {
}
exports.default = SubscriptionBankDetailsResource;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.ValidateIf)((obj) => obj.withoutPerceptionAccount !== undefined),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SubscriptionBankDetailsResource.prototype, "withoutPerceptionAccount", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails ? obj.perceptionTitularyName != null && obj.perceptionTitularyName !== "" : !obj.withoutPerceptionAccount || hasPerceptionAccount(obj)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionTitularyName", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((obj) => !obj.withoutPerceptionAccount || hasPerceptionAccount(obj)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBankDomiciliation", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(34, { context: [34] }),
    (0, class_validator_1.IsIBAN)(),
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails || !obj.withoutPerceptionAccount || hasPerceptionAccount(obj)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionIban", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(11, { context: [11] }),
    (0, class_validator_1.IsBIC)(),
    (0, class_validator_1.ValidateIf)((obj) => !obj.withoutPerceptionAccount || hasPerceptionAccount(obj)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBic", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], SubscriptionBankDetailsResource.prototype, "requiresHexaBankDetails", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(240, { context: [240] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBankAddress", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBankCity", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(30, { context: [30] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBankZipCode", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true),
    (0, class_validator_1.IsEnum)(ECountry_1.ECountry),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBankCountry", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true && obj.perceptionAccountNumber != null && obj.perceptionAccountNumber !== ""),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionAccountNumber", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true && obj.perceptionBankCountry === ECountry_1.ECountry.etats_unis && obj.perceptionAba != null && obj.perceptionAba !== ""),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(9, { context: [9] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_validator_1.Matches)(/^\d{9}$/, { message: "bankAbaInvalid" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionAba", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true && obj.perceptionBankContact != null && obj.perceptionBankContact !== ""),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(80, { context: [80] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(/\S/, { message: "isNotEmpty" }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionBankContact", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.requiresHexaBankDetails === true && obj.perceptionHasIban != null),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], SubscriptionBankDetailsResource.prototype, "perceptionHasIban", void 0);
